import React from 'react';
import ContentLoader from '@adsk/alloy-react-content-loader';
const ProfileLoader = () => /*#__PURE__*/React.createElement(ContentLoader, {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  style: {
    marginRight: 25
  }
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  rx: "100",
  ry: "100",
  width: "24",
  height: "24"
}));
ProfileLoader.displayName = 'ProfileLoader';
export default ProfileLoader;
//# sourceMappingURL=ProfileLoader.js.map